var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loading,"disabled":_vm.loading,"elevation":"0"},on:{"click":_vm.handleExport}},[_vm._v(" Exportar a excel "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-file-excel ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }